// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"485":"f1356052","578":"03284d7d"}[chunkId] + ".css";
};